export default __webpack_public_path__ + "static/media/MS00101.6fa5cc91.mp3";